import React, { useState, useEffect, useRef } from 'react';
import { Button, Container, Row, Col, Tabs, Tab } from "react-bootstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import moment from 'moment-jalaali'
import DatePicker from 'react-datepicker2';

import { Switch, Route, useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import {
    userActions,
    planActions,
    paymentActions,
} from '../../actions';

import { useTranslation } from 'react-i18next';

import PageTitle from "../../components/common/PageTitle";
import { user } from '../../reducers/user.reducer';

const PaymentsList = () => {
    const { SearchBar } = Search;
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isGregorian = true;
    // const user = useSelector(state => state.authentication.user);
    const location = useLocation();
    const { path, url } = useRouteMatch();
    const loading = useSelector(state => state.payment.loading);
    const payments = useSelector(state => state.payment.payments);
    const users = useSelector(state => state.user.users);
    const plans = useSelector(state => state.plan.plans);
    const [plansDetails, setPlansDetails] = useState()
    const [openModal, setOpenModal] = useState(false)
    const [usersList, setUsersList] = useState([])
    const [activeTab, setActiveTab] = useState()
    const [usersPayments, setUsersPayments] = useState([])
    const [planPayments, setPlanPayments] = useState([])
    const [couponPayments, setCouponPayments] = useState([])
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [editCode, setEditCode] = useState();
    const toggle = () => {
        setOpenModal(!openModal);
    }

    useEffect(() => {
        dispatch(paymentActions.report());
    }, [])

    useEffect(() => {
        let mainPayments = []
        payments.map(payment => {
            const planPayment = {
                id: payment._id || payment.id,
                ...payment,
                plan: `${payment.planIntervalCount} ${payment.planInterval}`
            }
            mainPayments.push(planPayment)
        })
        const paymentGroup = _.groupBy(mainPayments, 'username');
        let usersPayment = [];
        let planPayment = [];
        let couponPayment = [];
        for (const [key, value] of Object.entries(paymentGroup)) {
            let totalAmount = 0;
            let lastPayment;
            let lastPaymentDate;
            let coupon = 0;
            value.map(payment => {
                totalAmount += payment.amount;
                lastPayment = payment.amount;
                lastPaymentDate = payment.createdAt;
                if (payment.coupon.length) coupon++;
            })
            let user = {
                id: `user_${key}`,
                user: key,
                totalPayment: value.length,
                totalAmount: totalAmount,
                lastPayment: lastPayment,
                lastPaymentDate: lastPaymentDate,
                usedCoupon: coupon,
            }
            usersPayment.push(user);
        }
        setUsersPayments(usersPayment)
        const planGroup = _.groupBy(mainPayments, 'plan');
        for (const [key, value] of Object.entries(planGroup)) {
            let totalAmount = 0;
            let lastPayment;
            let lastPaymentDate;
            let coupon = 0;
            value.map(payment => {
                totalAmount += payment.amount;
                lastPayment = payment.amount;
                lastPaymentDate = payment.createdAt;
                if (payment.coupon.length) coupon++;
            })
            let plan = {
                id: `plan_${key}`,
                plan: key,
                totalPayment: value.length,
                totalAmount: totalAmount,
                lastPayment: lastPayment,
                lastPaymentDate: lastPaymentDate,
                usedCoupon: coupon,
            }
            planPayment.push(plan);
        }
        setPlanPayments(planPayment)
        const couponGroup = _.groupBy(mainPayments, 'coupon');
        for (const [key, value] of Object.entries(couponGroup)) {
            let totalAmount = 0;
            let lastPayment;
            let lastPaymentDate;
            value.map(payment => {
                totalAmount += payment.amount;
                lastPayment = payment.amount;
                lastPaymentDate = payment.createdAt;
            })
            let coupon = {
                id: `coupon_${key}`,
                coupon: key,
                totalPayment: value.length,
                totalAmount: totalAmount,
                lastPayment: lastPayment,
                lastPaymentDate: lastPaymentDate,
            }
            couponPayment.push(coupon);
        }
        setCouponPayments(couponPayment)
    }, [payments])

    useEffect(() => {
        let plansList = {}
        plans.map(plan => {
            plansList = {
                ...plansList,
                [plan._id]: {
                    currency: plan.currency,
                    intervalCount: plan.intervalCount,
                    amount: plan.amount,
                    interval: plan.interval
                }
            }
        })
        setPlansDetails(plansList);
    }, [plans])

    useEffect(() => {
        let usersLst = [];
        if (users.length > 0 && !_.isEmpty(plansDetails)) {
            users.map(user => {
                let plan = ''
                if (user.subscriptions && user.subscriptions.length > 0) {
                    const planInterval = plansDetails[user.subscriptions[0].plan];
                    const exp = dateDiff(user.subscriptions[0].currentPeriodEnd);
                    const planName = planInterval ? `${planInterval.intervalCount} ${planInterval.interval}` : `Free`
                    if (exp > 5) {
                        plan = `Active, ${planName}, ${exp} days`;
                    } else if (exp > 0) {
                        plan = `NearExpiration, ${planName}, ${exp} days`;
                    } else {
                        plan = `Expired, ${planName}, ${exp} days`;
                    }
                } else {
                    plan = '-'
                }
                const userDetail = {
                    id: user._id,
                    username: user.username,
                    fullName: `${_.get(user, 'firstname', '-')} ${_.get(user, 'lastname', '-')}`,
                    role: user.role,
                    createdAt: user.createdAt.split('T')[0],
                    plan: plan
                }
                usersLst.push(userDetail)
            })
        }
        setUsersList(usersLst)
    }, [plansDetails, users])

    const dateDiff = (date) => {
        const today = new Date();
        const expDate = new Date(date);
        const diffTime = (expDate - today);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays;
    }

    const columns = [
        {
            text: 'Username',
            dataField: 'username',
            formatter: usernameFormatter,
            sort: true,
        },
        {
            text: 'Amount',
            dataField: 'amount',
            formatter: amountFormatter,
        },
        {
            text: 'Plan',
            dataField: 'planInterval',
            formatter: planFormatter,
        },
        {
            text: 'Coupon',
            dataField: 'coupon',
        },
        {
            text: 'Date/Time',
            dataField: 'createdAt',
            formatter: dateFormatter,
        },
        // {
        //     text: 'Action',
        //     dataField: 'data.id',
        //     formatter: actionFormatter,
        // }
    ]

    const userColumns = [
        {
            text: 'Username',
            dataField: 'user',
            // formatter: usernameFormatter,
        },
        {
            text: 'Total Payment',
            dataField: 'totalPayment',
            sort: true,
        },
        {
            text: 'Total Amount',
            dataField: 'totalAmount',
            formatter: amountFormatter,
            sort: true,
        },
        {
            text: 'Used Coupon(s)',
            dataField: 'usedCoupon',
            sort: true,
        },
        {
            text: 'Last Amount',
            dataField: 'lastPayment',
            formatter: amountFormatter,
            sort: true,
        },
        {
            text: 'Last Payment Date/Time',
            dataField: 'lastPaymentDate',
            formatter: dateFormatter,
            sort: true,
        }
    ]
    const planColumns = [
        {
            text: 'Plan',
            dataField: 'plan',
            // formatter: usernameFormatter,
            sort: true,
        },
        {
            text: 'Total Payment',
            dataField: 'totalPayment',
            sort: true,
        },
        {
            text: 'Total Amount',
            dataField: 'totalAmount',
            formatter: amountFormatter,
            sort: true,
        },
        {
            text: 'Used Coupon(s)',
            dataField: 'usedCoupon',
            sort: true,
        },
        {
            text: 'Last Amount',
            dataField: 'lastPayment',
            formatter: amountFormatter,
            sort: true,
        },
        {
            text: 'Last Payment Date/Time',
            dataField: 'lastPaymentDate',
            formatter: dateFormatter,
            sort: true,
        }
    ]
    const couponColumns = [
        {
            text: 'coupon',
            dataField: 'coupon',
            // formatter: usernameFormatter,
            sort: true,
        },
        {
            text: 'Total Payment',
            dataField: 'totalPayment',
            sort: true,
        },
        {
            text: 'Total Amount',
            dataField: 'totalAmount',
            formatter: amountFormatter,
            sort: true,
        },
        // {
        //     text: 'Used Coupon(s)',
        //     dataField: 'usedCoupon',
        //     sort: true,
        // },
        {
            text: 'Last Amount',
            dataField: 'lastPayment',
            formatter: amountFormatter,
            sort: true,
        },
        {
            text: 'Last Payment Date/Time',
            dataField: 'lastPaymentDate',
            formatter: dateFormatter,
            sort: true,
        }
    ]

    function planFormatter(cell, row) {
        return `${row.planIntervalCount} ${_.capitalize(cell)}`;
    }
    function amountFormatter(cell, row) {
        const currency = cell > 1000 ? 'Rls' : 'Eru'
        return `${cell.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ${currency}`;
    }
    function dateFormatter(cell, row) {
        const date = new Date(cell)
        const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        return `${dayNames[date.getDay()]}, ${date.toLocaleString()}`
    }
    function usernameFormatter(cell, row) {
        return (
            <div className="tableTagBox">
                <span className="tableUsername">{cell}</span>
                <span className="tableName">{row.fullName}</span>
            </div>
        )
    }
    function actionFormatter(cell, row) {
        return (
            <div className="tableTempActionBox">
                <Button className="tableTempAction" theme="info"><i className="material-icons">info</i> Details</Button>
                <Button className="tableTempAction" onClick={() => editHandler(cell)}><i className="material-icons">edit</i> Edit</Button>
                <Button className="tableTempAction" theme="danger"><i className="material-icons">delete</i> Delete</Button>
            </div>
        )
    }

    const editHandler = (tempId) => {
        history.push(`template/${tempId}/edit`);
    }

    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
            Showing { from} to { to} of { size} Results
        </span>
    );

    const options = {
        paginationTotalRenderer: customTotal,
        showTotal: true,
        onSizePerPageChange: (sizePerPage, page) => {
            // console.log('Size per page change!!!');
            // console.log('Newest size per page:' + sizePerPage);
            // console.log('Newest page:' + page);
        },
        onPageChange: (page, sizePerPage) => {
            // console.log('Page change!!!');
            // console.log('Newest size per page:' + sizePerPage);
            // console.log('Newest page:' + page);
        }
    };

    const dateSearchHandler = () => {
        const date = {
            from: moment(startDate).toISOString(),
            to: moment(endDate).toISOString(),
        }
        dispatch(paymentActions.report(date));
    }

    return (
        <Container fluid className={`main-content-container px-4 ${loading ? 'blur' : ''}`}>
            {/* Page Header */}
            <Row noGutters className="page-header py-4">
                <PageTitle sm="4" title="Payments List" subtitle="Accounting" className="text-sm-left" />
            </Row>
            <Row noGutters className="dateFilterRow">
                <Col lg="2">
                    <span>Start Date:</span>
                    <DatePicker
                        id="startDate"
                        name="startDate"
                        disabled={editCode}
                        timePicker={false}
                        // value={formik.values.startDate}
                        // onChange={formik.handleChange}
                        onChange={value => setStartDate(value)}
                        value={startDate}
                        // min={moment().subtract(1, 'days')}
                        // setTodayOnBlur={false}
                        isGregorian={isGregorian}
                        inputFormat="YYYY/MM/DD"
                        inputJalaaliFormat="jYYYY/jMM/jDD"
                    />
                    {/* <input id="startDate" name="startDate" /> */}

                </Col>
                <Col lg="2">
                    <span>End Date:</span>
                    <DatePicker
                        name="endDate"
                        timePicker={false}
                        min={moment(startDate)}
                        value={endDate}
                        onChange={value => setEndDate(value)}
                        isGregorian={isGregorian}
                        setTodayOnBlur={false}
                        inputFormat="YYYY/MM/DD"
                        inputJalaaliFormat="jYYYY/jMM/jDD"
                    />
                </Col>
                <Col lg="2">
                    <Button disabled={!startDate || !endDate && true} onClick={dateSearchHandler}>Search</Button>
                </Col>
            </Row>

            <Tabs defaultActiveKey="allPayment" id="uncontrolled-tab-example" onSelect={(eventKey) => setActiveTab(eventKey)}>
                <Tab eventKey="allPayment" title="All payments">
                    <Row>
                        <Col>
                            <ToolkitProvider
                                keyField="_id"
                                data={payments}
                                columns={columns}
                                search
                            >
                                {
                                    props => (
                                        <div>
                                            <SearchBar {...props.searchProps} />
                                            <hr />
                                            <BootstrapTable
                                                {...props.baseProps}
                                                keyField="_id"
                                                pagination={paginationFactory(options)}
                                            />
                                        </div>
                                    )
                                }
                            </ToolkitProvider>
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="byUsers" title="By Users">
                    <Row>
                        <Col>
                            <ToolkitProvider
                                keyField="user"
                                data={usersPayments}
                                columns={userColumns}
                                search
                            >
                                {
                                    props => (
                                        <div>
                                            <SearchBar {...props.searchProps} />
                                            <hr />
                                            <BootstrapTable
                                                {...props.baseProps}
                                                keyField="user"
                                                pagination={paginationFactory(options)}
                                            />
                                        </div>
                                    )
                                }
                            </ToolkitProvider>
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="byPlan" title="By Plan">
                    <Row>
                        <Col>
                            <ToolkitProvider
                                keyField="plan"
                                data={planPayments}
                                columns={planColumns}
                                search
                            >
                                {
                                    props => (
                                        <div>
                                            <SearchBar {...props.searchProps} />
                                            <hr />
                                            <BootstrapTable
                                                {...props.baseProps}
                                                keyField="plan"
                                                pagination={paginationFactory(options)}
                                            />
                                        </div>
                                    )
                                }
                            </ToolkitProvider>
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="byCoupon" title="By Coupon">
                    <Row>
                        <Col>
                            <ToolkitProvider
                                keyField="coupon"
                                data={couponPayments}
                                columns={couponColumns}
                                search
                            >
                                {
                                    props => (
                                        <div>
                                            <SearchBar {...props.searchProps} />
                                            <hr />
                                            <BootstrapTable
                                                {...props.baseProps}
                                                keyField="coupon"
                                                pagination={paginationFactory(options)}
                                            />
                                        </div>
                                    )
                                }
                            </ToolkitProvider>
                        </Col>
                    </Row>
                </Tab>
            </Tabs>
        </Container>
    );
}

export default PaymentsList;
